<script setup lang="ts">
import { FormInputDate } from "../types";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const props = defineProps<{
  config: FormInputDate;
  modelValue: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: string) => emit("update:modelValue", value),
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
</script>

<template>
  <AppDateTimePicker
    v-model="value"
    v-bind="config"
    :config="{
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
    }"
    :label="config.label ? $t(config.label) : undefined"
    :disabled="disabled"
  />
</template>
